import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  text: {
    marginTop: '6px'
  },
  actions: {
    marginTop: '24px'
  },
  bannerContent: {
    '& p': {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '400',
      color: palette.shades[800],
      margin: '0'
    },
    '& h1': {
      fontFamily: palette.fontFamilies.poppins,
      fontSize: '40px',
      lineHeight: '60px',
      fontWeight: 700,
      margin: '0',
      color: palette.shades[800]
    },
    '& h2': {
      fontFamily: palette.fontFamilies.poppins,
      fontSize: '32px',
      lineHeight: '48px',
      fontWeight: 600,
      margin: '0',
      color: palette.shades[800]
    },
    '& h3': {
      fontFamily: palette.fontFamilies.poppins,
      fontSize: '24px',
      lineHeight: '36px',
      fontWeight: 600,
      margin: '0',
      color: palette.shades[800]
    },
    '& h4': {
      fontFamily: palette.fontFamilies.poppins,
      fontSize: '18px',
      lineHeight: '27px',
      fontWeight: 600,
      margin: '0',
      color: palette.shades[800]
    },
    '& h5': {
      fontFamily: palette.fontFamilies.poppins,
      fontSize: '15px',
      lineHeight: '22px',
      fontWeight: 600,
      marginBottom: '4px',
      margin: '0',
      color: palette.shades[800]
    },
    '& h6': {
      fontFamily: palette.fontFamilies.poppins,
      fontSize: '13px',
      lineHeight: '19px',
      fontWeight: 600,
      marginBottom: '4px',
      margin: '0',
      color: palette.shades[800]
    }
  },
  alertWrapper: {
    marginBottom: '32px',
    '& .MuiAlert-root': {
      padding: '40px 50px 40px 50px'
    },
    '& .MuiAlert-standardInfo': {
      '& .MuiTypography-h4': {
        color: palette.info.dark
      },
      '& p, h1, h2, h3, h4, h5, h6': {
        color: palette.info.dark
      },
      '& .MuiAlert-action path': {
        fill: palette.shades[700]
      },
      '& .MuiButton-text': {
        color: palette.info.main
      }
    },
    '& .MuiAlert-standardSuccess': {
      '& .MuiTypography-h4': {
        color: palette.success.dark
      },
      '& p, h1, h2, h3, h4, h5, h6': {
        color: palette.success.dark
      },
      '& .MuiAlert-action path': {
        fill: palette.shades[700]
      },
      '& .MuiButton-text': {
        color: palette.success.main
      }
    },
    '& .MuiAlert-standardWarning': {
      '& .MuiTypography-h4': {
        color: palette.warning.dark
      },
      '& p, h1, h2, h3, h4, h5, h6': {
        color: palette.warning.dark
      },
      '& .MuiAlert-action path': {
        fill: palette.shades[700]
      },
      '& .MuiButton-text': {
        color: palette.warning.main
      }
    },
    '& .MuiAlert-standardError': {
      '& .MuiTypography-h4': {
        color: palette.error.dark
      },
      '& p, h1, h2, h3, h4, h5, h6': {
        color: palette.error.dark
      },
      '& .MuiAlert-action path': {
        fill: palette.shades[700]
      },
      '& .MuiButton-text': {
        color: palette.error.main
      }
    }
  }
});
export default useStyles;